/* Formatação de CPF/CNPJ para exibição.
   Vive aqui, e não dentro de um módulo, porque a tela de emissão de NFS-e
   precisa do mesmo formato que o cadastro de clientes -- duas cópias
   divergiriam na primeira correção. */

export function formatarDocumento(doc) {
  const d = String(doc || '').replace(/\D/g, '');
  if (d.length === 14) return d.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, '$1.$2.$3/$4-$5');
  if (d.length === 11) return d.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})$/, '$1.$2.$3-$4');
  /* fora dos tamanhos conhecidos devolve como veio: documento incompleto
     ou estrangeiro não deve sumir da tela só por não casar com a máscara */
  return doc || '';
}

export function soDigitos(v) {
  return String(v || '').replace(/\D/g, '');
}

/* Máscara enquanto digita: até 11 dígitos segue o desenho do CPF, do 12º em
   diante vira CNPJ. Guarda-se só os dígitos; isto é só o que aparece. */
export function mascararDocumento(v) {
  const d = soDigitos(v).slice(0, 14);
  if (d.length <= 11) {
    return d.replace(/^(\d{3})(\d)/, '$1.$2')
      .replace(/^(\d{3})\.(\d{3})(\d)/, '$1.$2.$3')
      .replace(/\.(\d{3})(\d{1,2})$/, '.$1-$2');
  }
  return d.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{0,2})$/, (_, a, b, c, e, f) => `${a}.${b}.${c}/${e}${f ? `-${f}` : ''}`);
}

export function mascararCep(v) {
  const d = soDigitos(v).slice(0, 8);
  return d.length > 5 ? `${d.slice(0, 5)}-${d.slice(5)}` : d;
}
